import { z } from 'zod';

export const loginFormSchema = z.object({
  email: z
    .string()
    .email({
      message: 'Введите корректный адрес электронной почты',
    })
    .min(3, { message: 'Минимальная длина логина 3 символа' }),
  password: z
    .string()
    .min(6, { message: 'Минимальная длина пароля 6 символов' }),
});
